import Cookies from "js-cookie";
import { useCallback } from "react";

const useStorage = () => {
  // Local Storage
  const setLocalStorage = useCallback((key, value) => {
    localStorage.setItem(key, JSON.stringify(value));
  }, []);

  const getLocalStorage = useCallback((key) => {
    const value = localStorage.getItem(key);
    return value ? JSON.parse(value) : null;
  }, []);

  const removeLocalStorage = useCallback((key) => {
    localStorage.removeItem(key);
  }, []);

  // Session Storage
  const setSessionStorage = useCallback((key, value) => {
    sessionStorage.setItem(key, JSON.stringify(value));
  }, []);

  const getSessionStorage = useCallback((key) => {
    const value = sessionStorage.getItem(key);
    return value ? JSON.parse(value) : null;
  }, []);

  const removeSessionStorage = useCallback((key) => {
    sessionStorage.removeItem(key);
  }, []);

  // Cookies
  const setCookie = useCallback((key, value, options) => {
    Cookies.set(key, value, options);
  }, []);

  const getCookie = useCallback((key) => {
    return Cookies.get(key);
  }, []);

  const removeCookie = useCallback((key) => {
    Cookies.remove(key);
  }, []);

  return {
    // Local Storage
    setLocalStorage,
    getLocalStorage,
    removeLocalStorage,

    // Session Storage
    setSessionStorage,
    getSessionStorage,
    removeSessionStorage,

    // Cookies
    setCookie,
    getCookie,
    removeCookie,
  };
};

export default useStorage;
